export const ADMIN_TYPES = {
  SUPER_ADMIN: "super_admin",
  RECIPE_GROUP_ADMIN: "recipe_group_admin",
  RECIPE_ADMIN: "recipe_admin",
  GROUP_ADMIN: "group_admin",
};

const ALL_ROLES = Object.values(ADMIN_TYPES);
const SUPER_ONLY = [ADMIN_TYPES.SUPER_ADMIN];
const GROUP_ROLES = [
  ADMIN_TYPES.SUPER_ADMIN,
  ADMIN_TYPES.RECIPE_GROUP_ADMIN,
  ADMIN_TYPES.GROUP_ADMIN,
];
const RECIPE_ROLES = [
  ADMIN_TYPES.SUPER_ADMIN,
  ADMIN_TYPES.RECIPE_GROUP_ADMIN,
  ADMIN_TYPES.RECIPE_ADMIN,
];

export const NAV_ITEMS = [
  {
    name: "Dashboard",
    pathname: "/dashboard",
    activeTab: ["/dashboard"],
    roles: ALL_ROLES,
  },
  {
    name: "Groups",
    pathname: "/groups",
    activeTab: ["/groups"],
    roles: GROUP_ROLES,
  },
  {
    name: "Full Circle",
    pathname: "/full-circle",
    activeTab: ["/full-circle"],
    roles: SUPER_ONLY,
  },
  {
    name: "Admins",
    pathname: "/admins",
    activeTab: ["/admins"],
    roles: SUPER_ONLY,
  },
  {
    name: "Ingredients",
    pathname: "/ingredients",
    activeTab: ["/ingredients"],
    roles: RECIPE_ROLES,
  },
  {
    name: "Recipes",
    pathname: "/recipes",
    activeTab: ["/recipes", "/new-recipes", "/edit-recipes"],
    roles: RECIPE_ROLES,
  },
  {
    name: "Category",
    pathname: "/categories",
    activeTab: ["/categories"],
    roles: RECIPE_ROLES,
  },
  {
    name: "Meal Plans",
    pathname: "/meal-Plans",
    activeTab: ["/meal-Plans", "/new-meal-Plan", "/edit-meal-Plan"],
    roles: RECIPE_ROLES,
  },
  {
    name: "Products",
    pathname: "/products",
    activeTab: ["/products", "/add-product", "/edit-product"],
    roles: SUPER_ONLY,
  },
  {
    name: "Featured",
    pathname: "/featured",
    activeTab: ["/featured"],
    roles: SUPER_ONLY,
  },
  {
    name: "Fully Fit",
    pathname: "/fully-fit",
    activeTab: ["/fully-fit"],
    roles: SUPER_ONLY,
  },
  {
    name: "Push Notifications",
    pathname: "/push-notifications",
    activeTab: ["/push-notifications"],
    roles: SUPER_ONLY,
  },
  {
    name: "Faq",
    pathname: "/faq",
    activeTab: ["/faq"],
    roles: SUPER_ONLY,
  },
  {
    name: "Users",
    pathname: "/users",
    activeTab: ["/users"],
    roles: GROUP_ROLES,
  },
  {
    name: "Reports",
    pathname: "/reports",
    activeTab: ["/reports"],
    roles: SUPER_ONLY,
  },
];

const EXTRA_ROUTE_PERMISSIONS = [
  {
    activeTab: [
      "/promotional-offer",
      "/add-promotional-offer",
      "/edit-promotional-offer",
    ],
    roles: SUPER_ONLY,
  },
  {
    activeTab: ["/subscribers"],
    roles: SUPER_ONLY,
  },
];

const ROUTE_PERMISSIONS = [...NAV_ITEMS, ...EXTRA_ROUTE_PERMISSIONS];

const matchesPath = (pathname, pattern) => {
  if (pathname === pattern) return true;
  return pathname.startsWith(`${pattern}/`);
};

const findRoutePermission = (pathname) =>
  ROUTE_PERMISSIONS.find((item) =>
    item.activeTab.some((tab) => matchesPath(pathname, tab))
  );

export const canAccess = (pathname, userType) => {
  if (!userType) return false;

  const route = findRoutePermission(pathname);

  if (!route) {
    return userType === ADMIN_TYPES.SUPER_ADMIN;
  }

  return route.roles.includes(userType);
};

/**
 * Users screen actions, mirroring the backend role checks
 * (fullyraw-backend-v2: routes/index.js + models/admin/update_user.js).
 * - editProfile: name, last name, location, bio, remove photo
 * - editAccount: email, phone, subscription, community access
 * - deleteAccount: permanently remove the user
 */
const USER_MANAGEMENT = {
  editProfile: GROUP_ROLES,
  editAccount: SUPER_ONLY,
  deleteAccount: SUPER_ONLY,
};

export const canManageUsers = (action, userType) =>
  !!userType && (USER_MANAGEMENT[action] || []).includes(userType);

export const getDefaultRoute = (userType) => {
  const firstAllowed = NAV_ITEMS.find((item) =>
    item.roles.includes(userType)
  );
  return firstAllowed?.pathname ?? "/dashboard";
};
